export const AcceptedGenders = {
  MALE: "male",
  FEMALE: "female",
  OTHER: "other",
  NOT_ACCEPTED: "NOT ASSIGNED",
};
